<template>
  <!-- 页面容器 -->
  <div class="page-container">
    <!-- 页面头部 -->
    <div>
      <div class="page-card__header">
        <span style="padding-right: 20px"> 参展人员（共{{aSum}}人）</span>
      </div>
    </div>
    <!-- 数据表格 -->
    <el-table
      :data="tableData"
      style="width: 100%;padding: 0 20px;"
    >

      <el-table-column
        prop="wx_user_detail.name"
        label="姓名"

      >
      </el-table-column>

      <el-table-column
        prop="wx_user_detail.position"
        label="职务"

      >
      </el-table-column>
      <el-table-column
        prop="wx_user_detail.company"
        label="公司"

      >
      </el-table-column>

      <el-table-column
        label="参展">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.exhibition"  size="small">是</el-tag>
          <el-tag v-else  type="warning">否</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="参观"
        width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.visit" size="small">是</el-tag>
          <el-tag v-else  type="warning">否</el-tag>
        </template>
      </el-table-column>


      <el-table-column
        prop="update_time"
        label="日期">
      </el-table-column>
      <!-- 操作列 -->
      <el-table-column
        fixed="right"
        label="操作"
        width="80">
        <template slot-scope="scope">
          <el-button type="text" class="action-btn--danger" @click="deleteInfo(scope.row)">删除</el-button>
        </template>
      </el-table-column>


    </el-table>
    <!-- 分页 -->
    <div class="pagination-wrap">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :total="aSum"
        :page-count="pageCount"
        :current-page.sync="currentPage"
        background
        layout="prev, pager, next,jumper"
      >
      </el-pagination>
    </div>


  </div>

</template>

<script>
  import api from '../../utils/api'

  export default {

    data() {
      return {
        changetype: true,
        changeID: 0,
        tableData: [],
        //分页
        // 总条目数 total
        aSum: 0,
        // 当前页数 currenr_page
        currentPage: 1,
        // 总页数 num_pages
        pageCount: 1,
        // 每页显示条目数 pagesize
        pagesize: 10,
      }
    },
    components: {

    },
    mounted() {
      this.getinfo();
    },
    methods: {
      // 获取参展人员列表
      getinfo() {
        let url = this.baseUrl + "/admin/attendees/?ordering=-create_time";
        api.fetchData(url).then(res => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = 1;
        })
      },

      // 分页切换
      handleCurrentChange(val) {
        let url = this.baseUrl + "/admin/attendees/?ordering=-create_time&page=" + val;
        api.fetchData(url).then(res => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = val;
        });
      },

      // 删除参展人员信息
      deleteInfo(row) {
        this.$confirm('将删除此条信息，是否继续', '提示', {
          confirmButtonText: "确定",
          cancelButtonText: '取消',
          type: "warning"
        }).then(() => {
          let id = row.id;
          let url = this.baseUrl + "/admin/attendees/" + id + "/";
          api.deleteData(url).then(res => {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getinfo();
          })
        })
      },

      // 切换页面类型
      changePage() {
        this.changetype = true;
      },
      // 切换到命中页面
      changePage_hit() {
        this.changetype = false;
      },
      // 跳转到详情页
      handleClick() {
        this.$router.push({name: 'admin_exhibitorDetails'})
      },
    },
  }
</script>

<style scoped>
  .changtype {
    background-color: var(--color-primary);
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/personList.vue